import { useMemo } from "react";

import { casesApi } from "src/api/endpoints";
import { useCurrentWorkspace } from "src/api/queries";

export const useCasesClient = () => {
  const { data: workspace } = useCurrentWorkspace();

  return useMemo(
    () => (workspace?.base_url ? casesApi(workspace.base_url) : undefined),
    [workspace?.base_url],
  );
};
